"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("./constant");
var _default = exports.default = {
  PropTypes: {
    loyaltyTier: _propTypes.default.oneOf(_constant.MEMBER_TYPES).isRequired,
    width: _propTypes.default.string,
    height: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object
  },
  DefaultProps: {
    accessible: true
  }
};